import type { PropsWithChildren } from 'react'
import { IconButton } from '~/shared/ui/icon-button'
import { Stepper } from './stepper/stepper'

export function ResourceLayout({
  children,
  steps,
  activeStepIndex,
  backUrl,
  actions,
  assetCard,
}: PropsWithChildren<{
  steps: Array<{
    route?: string
    label: string
    accessible?: boolean
    finished?: boolean
    flagged?: boolean
    flagSeverity?: 'high' | 'low'
    lockedReason?: string
  }>
  activeStepIndex: number
  backUrl: string
  actions?: React.ReactNode
  assetCard?: React.ReactNode
}>) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-divider bg-surface-lowest flex h-[72px] shrink-0 items-center justify-between border-b pr-4 pl-2">
        <div className="flex items-center">
          <IconButton
            to={backUrl}
            size="medium"
            container="medium"
            materialIcon="arrow_back"
          />
          {assetCard}
        </div>
        <Stepper
          steps={steps}
          activeStepIndex={activeStepIndex}
        />
        <div className="flex h-full min-w-[150px] items-center">{actions}</div>
      </div>
      <div className="w-full flex-1 overflow-hidden">{children}</div>
    </div>
  )
}
